import { Modal } from "react-bootstrap";
import { ModalInformationContentStyled, ModalInformationStyled, ModalWrapperStyled } from "./styled/ModalsStyled.js";
import WithdrawalRequestSent from "../Account/components/WithdrawalRequestSent/WithdrawalRequestSent";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { openModalAction } from "../../app/appActions";
import { MODALS_NAME } from "./modalsConstants";

function WithdrawalRequestSentModal(props) {
    const dispatch = useDispatch();

    const onHistoryClick = useCallback(() => {
        dispatch(openModalAction({name: MODALS_NAME.CASHIER, tab: 'history'}))
    }, [dispatch]);

    return <ModalInformationStyled>
        <Modal.Header style={{background: 'transparent'}} closeButton/>
        <ModalWrapperStyled>
            <ModalInformationContentStyled>
                <WithdrawalRequestSent
                    onHistoryClick={onHistoryClick}
                    onContinueTradingClick={props.closeModal}
                />
            </ModalInformationContentStyled>
        </ModalWrapperStyled>
    </ModalInformationStyled>
}

export default WithdrawalRequestSentModal;
